import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/_withoutDataScaffold/invite/$inviteId",
)({
    loader: () => {
        throw redirect({to: "/u/select-workspace"});
    },
    component: RouteComponent,
});

function RouteComponent() {
    return null;
}
